const configDB = {
  layout_type: "ltr",
  mix_background_layout: "light",
};

export default configDB;
